import React, {Component} from "react"
import {Modal, Form, Input, Button, Checkbox} from "antd"
import { toast } from "react-toastify"
import { Link } from "react-router-dom"
import * as Yup from 'yup';
import * as IntlTelInput from 'intl-tel-input'
import * as firebase from 'firebase/app';
import 'firebase/auth';

toast.configure({
    position: "bottom-right"
});

const PHONE_OR_EMAIL = {
	phone: "phone",
	email: "email"
}

class SignUpModal extends Component {

    emailRegex = RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);    
    passwordRegex = RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/);
    phoneRegex = RegExp(/^\+(?:[0-9]●?){6,14}[0-9]$/);

    state = {
        signInState: false,
        email: "",
        password: "",
        username: "",
        fullname: "",
        sPhoneNumber: "",
        dialCode: "",
        countries: [],
        currentType: PHONE_OR_EMAIL.email,
        errors: {
            fullname: null,
            email: null,
            password: null
        },
        formErrors: {
            fullNameValidation: "",
            emailValidation: "",
            passwordValidation: "",
        },
    }
	
	switchType = () => {
		this.setState({
			currentType: this.state.currentType === PHONE_OR_EMAIL.email ? PHONE_OR_EMAIL.phone : PHONE_OR_EMAIL.email
		})
    }

    passwordSchema = Yup.string()
        .required("Your password is required.")
        .min(6, "A strong password should be a minimum of 6 characters.")
        .matches(this.passwordRegex, "A strong password should include a number, capital letters and small letters.")

    emailSchema = Yup.string()
        .required("Your email is required.")
        .email("Please enter a valid email.");
    
    fullnameSchema = Yup.string()
        .required("Your full name is required.")
        .min(3, "Your full name should be at least 3 characters.")
    
    phoneSchema = Yup.string()
        .required("Your phone nnumber is required.")
        .matches(this.phoneRegex, "Please enter a valid phone number.")
    
    emailValidationSchema = Yup.object().shape({
        password: this.passwordSchema,
        email: this.emailSchema,
        fullname: this.fullnameSchema
    })

    phoneValidationSchema = Yup.object().shape({
        sPhoneNumber: this.phoneSchema,
        fullname: this.fullnameSchema
    })

    ini_ = null;
    recaptchaVerifier = null;

	componentDidUpdate(prevProps, prevState){
        const this_ = this;
		if(this.state.countries.length === 0 && prevState.countries.length === 0){
			if(this.state.currentType === PHONE_OR_EMAIL.phone){
                const input = document.getElementById("sPhoneNumber");
                firebase.auth().useDeviceLanguage();
                this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("signUpRecaptchaContainer", {
                    'size': 'invisible'
                });
                this.recaptchaVerifier.render();

				this.ini_ = IntlTelInput(input, {
                    preferredCountries: [],
                    separateDialCode: true
                });
                this_.setState({
                    dialCode: this_.ini_.getSelectedCountryData().dialCode
                })
                input.addEventListener("countrychange", function() {
                    this_.setState({
                        dialCode: this_.ini_.getSelectedCountryData().dialCode
                    }) 
                });
				try {
					const countries = window.intlTelInputGlobals.getCountryData();
					this.setState({
						countries
					})
				} catch(error){
					toast("Something went wrong. Please, try again!", { type: "error"});
				} 
			}
        }
        

		if(prevProps.visible && !this.props.visible){
			this.resetForm()
		}
	}

    handleSubmit =  async (e) => {
        if(this.state.currentType === PHONE_OR_EMAIL.email){
            this.emailValidationSchema.validate({
                email: this.state.email,
                password: this.state.password,
                fullname: this.state.fullname
            }).then( res => {
                this.setState({
                    errors: {}
                });
                this.props.onCreate({
                    email: this.state.email,
                    password: this.state.password,
                    fullname: this.state.fullname,
                    status: "User",
                });
            }).catch( res => {
                if(res.errors.length > 0){
                    this.setState({
                        errors: {
                            [res.path]: res.message
                        }
                    });
                }
            })
        } else {
            this.phoneValidationSchema.validate({
                sPhoneNumber: `+${this.state.dialCode}${this.state.sPhoneNumber}`,
                fullname: this.state.fullname
            }).then( res => {
                this.setState({
                    errors: {}
                });
                this.props.signUpWithPhone({
                    phone: `+${this.state.dialCode}${this.state.sPhoneNumber}`,
                    fullname: this.state.fullname,
                    status: "User",
                    recaptchaVerifier: this.recaptchaVerifier
                })
            }).catch( res => {
                if(res.errors.length > 0){
                    this.setState({
                        errors: {
                            [res.path]: res.message
                        }
                    });
                }
            })

        }
    }

    handleChange = e => {
        e.preventDefault();
        this.setState({
            [e.target.name]: e.target.value
        });
    };


	handleCancel = (event) => {
		this.props.onCancel(event);
		this.resetForm()
	}

	resetForm = () => {
	}

    formRef = React.createRef()

    render() {
        const {formErrors} = this.state;
        const {
            visible,
            formRef,
            onCheckBox,
            onCheckBoxClick,
        } = this.props

        return (
            <React.Fragment>
                <Modal
                    className='login_block'
                    visible={visible}
                    okText='Recover'
                    onCancel={this.handleCancel}
                    footer={null}
                >
                    <div className='modalPayment'>
                        <div className='signInDescription'>
                            <img
                                alt="graduation cap"
                                width='50px'
                                height='50px'
                                src={require("../icons/user-graduate.svg")}
                            />
                        </div>
                        <div className='signInDescription'>
							<p
								className='createAccount'
								onClick={this.switchType}
							>
								{
									this.state.currentType === PHONE_OR_EMAIL.email ? 
										"Sign Up with a Phone Number" :
										"Sign Up with an Email"
								}
							</p>
						{
							this.state.currentType === PHONE_OR_EMAIL.phone ? 
								"We’ll send you a code to verify your account." : 
								"We’ll send you a link to verify your account." 
						}
                        </div>
                        <div className='loginForm'>
                            <Form
                                ref={formRef}
                                labelCol={{span: 5}}
                                wrapperCol={{span: 12}}
                                onFinish={this.handleSubmit}
                            >
                                <div className='centralButton'>
                                    <Form.Item
                                        hasFeedback={this.state.errors.fullname != null}
                                        validateStatus={this.state.errors.fullname != null ? "error" : "success"}
                                        help={this.state.errors.fullname != null ? this.state.errors.fullname : ""}
                                    >
                                        <Input
                                            type='text'
                                            placeholder='Full name'
                                            name="fullname"
                                            noValidate
                                            onChange={this.handleChange}
                                        />
                                        </Form.Item>
                                        <Form.Item
                                            style={{display: this.state.currentType === PHONE_OR_EMAIL.phone ? "block" : "none"}}
                                            hasFeedback={this.state.errors.sPhoneNumber != null}
                                            validateStatus={this.state.errors.sPhoneNumber != null ? "error" : "success"}
                                            help={this.state.errors.sPhoneNumber != null ? this.state.errors.sPhoneNumber : ""}
                                        >
                                            <Input
                                                name="sPhoneNumber"
                                                type="tel"
                                                id="sPhoneNumber"
                                                value={this.state.sPhoneNumber}
                                                onChange={this.handleChange}
                                                style={{
                                                    width: '100%',
                                                }}
                                            />
                                        </Form.Item> 
										<Form.Item
                                            style={{display: this.state.currentType === PHONE_OR_EMAIL.phone ? "none" : "block"}}
											hasFeedback={this.state.errors.email != null}
											validateStatus={this.state.errors.email != null ? "error" : "success"}
											help={this.state.errors.email != null ? this.state.errors.email : ""}
										>
											<Input
												type='email'
                                                name="email"
												onChange={this.handleChange}
												placeholder='Email'
											/>
										</Form.Item>
                                    <Form.Item
                                        hasFeedback={this.state.errors.password != null}
                                        style={{display: this.state.currentType === PHONE_OR_EMAIL.phone ? "none" : "block"}}
                                        validateStatus={this.state.errors.password != null ? "error" : "success"}
                                        help={this.state.errors.password != null ? this.state.errors.password : ""}
                                    >
                                        <Input
                                            type='password'
                                            placeholder='Password'
                                            name="password"
                                            noValidate
                                            onChange={this.handleChange}
                                        />
                                    </Form.Item>
                                    
                                </div>
                                <div className='checkBoxSignIn' style={{marginTop: 20}}>
                                    <Checkbox
                                        checked={onCheckBox}
                                        onChange={onCheckBoxClick}
                                    >
                                        By ticking this box, I verified that I
                                        have read the <Link target="_blank" to="/policy">Privacy Policy</Link> and have
                                        agreed to the <Link target="_blank" to="/terms">Terms &amp; Conditions</Link>
                                    </Checkbox>
                                </div>

                                <div 
                                    id="signUpRecaptchaContainer"
                                    style={{display: this.state.currentType === PHONE_OR_EMAIL.phone ? "block" : "none"}}
                                ></div>
                                <div className='centralSignUpButton'>
                                    <Form.Item>
                                        <Button
                                            className='coinButton profileApply'
                                            type='primary'
                                            htmlType='submit'
                                            disabled={formErrors.fullNameValidation.length > 0 ||
                                            formErrors.emailValidation.length > 0 ||
                                            formErrors.passwordValidation.length > 0}
                                        >
                                            Sign Up
                                        </Button>
                                    </Form.Item>
                                </div>
                            </Form>
                        </div>
                        <div className='signInDescription'>
                            Or
                            <br />
                            <br />
                            <span
                                className='createAccount'
                                onClick={this.props.openSignIn}
                            >
								Sign In{" "}
							</span>
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}

export default SignUpModal
